var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useMemo, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { notification } from 'antd';
import { receiveItems } from '../../redux/authSlice';
var authHeaders = function () {
    var _a;
    return ({
        moquiSessionToken: (_a = localStorage.getItem('moquiSessionToken')) !== null && _a !== void 0 ? _a : ''
    });
};
var PREFERENCES_STORAGE_KEY = 'receiving:productLocationPreferences';
var readStoredPreferences = function () {
    try {
        var raw = localStorage.getItem(PREFERENCES_STORAGE_KEY);
        if (!raw)
            return {};
        var parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' ? parsed : {};
    }
    catch (_a) {
        return {};
    }
};
var writeStoredPreferences = function (prefs) {
    try {
        localStorage.setItem(PREFERENCES_STORAGE_KEY, JSON.stringify(prefs));
    }
    catch (_a) {
        // do nothing
    }
};
export var useReceivingQueue = function (_a) {
    var shipmentId = _a.shipmentId, shipmentItemDetailList = _a.shipmentItemDetailList, shipmentLocationTypeList = _a.shipmentLocationTypeList, _b = _a.rejectedQtyByProductId, rejectedQtyByProductId = _b === void 0 ? {} : _b, _c = _a.__containerizedV2Flag__, __containerizedV2Flag__ = _c === void 0 ? false : _c, onAfterReceive = _a.onAfterReceive;
    var dispatch = useDispatch();
    var _d = useState([]), queue = _d[0], setQueue = _d[1];
    var _e = useState({}), locationCache = _e[0], setLocationCache = _e[1];
    var _f = useState(''), scanError = _f[0], setScanError = _f[1];
    var _g = useState({}), productNotAssociatedWithShipment = _g[0], setProductNotAssociatedWithShipment = _g[1];
    var _h = useState(null), pendingUnassociatedRow = _h[0], setPendingUnassociatedRow = _h[1];
    var approvedUnassociatedProductIdsRef = useRef(new Set());
    var _j = useState(false), isScanLoading = _j[0], setIsScanLoading = _j[1];
    var _k = useState(false), isSubmitting = _k[0], setIsSubmitting = _k[1];
    var _l = useState(readStoredPreferences), productLocationPreferences = _l[0], setProductLocationPreferences = _l[1];
    var suggestedLocations = useMemo(function () {
        // Count how many queued products are stored at each location (one count
        // per product, even if a product lists the location more than once), and
        // keep the first option seen for each location's label/type.
        var countByKey = new Map();
        var firstByKey = new Map();
        queue.forEach(function (row) {
            var perProductSeen = new Set();
            (locationCache[row.productId] || []).forEach(function (loc) {
                if (!(loc === null || loc === void 0 ? void 0 : loc.key) || perProductSeen.has(loc.key))
                    return;
                perProductSeen.add(loc.key);
                countByKey.set(loc.key, (countByKey.get(loc.key) || 0) + 1);
                if (!firstByKey.has(loc.key))
                    firstByKey.set(loc.key, loc);
            });
        });
        var out = [];
        firstByKey.forEach(function (loc, key) {
            out.push(__assign(__assign({}, loc), { productCount: countByKey.get(key) || 0 }));
        });
        return out;
    }, [queue, locationCache]);
    var fetchSuggestedLocationsFor = useCallback(function (productId) { return __awaiter(void 0, void 0, void 0, function () {
        var facilityId, response, assetList, mapped_1, _a;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (locationCache[productId])
                        return [2 /*return*/];
                    facilityId = (_b = localStorage.getItem('facilityId')) !== null && _b !== void 0 ? _b : '';
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/" + facilityId + "/scannedProductLocationDetails?scanId=" + productId, { headers: authHeaders() })];
                case 2:
                    response = _e.sent();
                    assetList = ((_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.scannedProductLocationDetails) === null || _d === void 0 ? void 0 : _d.assetList) || [];
                    mapped_1 = assetList
                        .filter(function (item) { return item === null || item === void 0 ? void 0 : item.locationSeqId; })
                        .map(function (item) {
                        var matched = shipmentLocationTypeList === null || shipmentLocationTypeList === void 0 ? void 0 : shipmentLocationTypeList.find(function (entry) { return (entry === null || entry === void 0 ? void 0 : entry.enumId) === (item === null || item === void 0 ? void 0 : item.locationTypeEnumId); });
                        return {
                            key: item.locationSeqId,
                            value: (matched === null || matched === void 0 ? void 0 : matched.description)
                                ? item.locationSeqId + " - " + matched.description
                                : item.locationSeqId,
                            locationTypeEnumId: item.locationTypeEnumId
                        };
                    });
                    setLocationCache(function (prev) {
                        var _a;
                        return (__assign(__assign({}, prev), (_a = {}, _a[productId] = mapped_1, _a)));
                    });
                    return [3 /*break*/, 4];
                case 3:
                    _a = _e.sent();
                    setLocationCache(function (prev) {
                        var _a;
                        return (__assign(__assign({}, prev), (_a = {}, _a[productId] = [], _a)));
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [locationCache, shipmentLocationTypeList]);
    // Validate a manually entered/scanned receiving location against the
    // facility. Mirrors the bulk flow's 'scanReceivingLocation' check: rejects
    // server messages and cart/pack location types, and resolves the canonical
    // locationSeqId from the response (which may differ from the raw barcode).
    var validateLocation = useCallback(function (rawLocation) { return __awaiter(void 0, void 0, Promise, function () {
        var scanId, facilityId, activeOrgId, response, data, locationSeqId, locationTypeEnumId_1, matched, _a;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    scanId = rawLocation.trim();
                    if (!scanId)
                        return [2 /*return*/, { ok: false, error: 'Enter a location' }];
                    facilityId = (_b = localStorage.getItem('facilityId')) !== null && _b !== void 0 ? _b : '';
                    activeOrgId = (_c = localStorage.getItem('activeOrgId')) !== null && _c !== void 0 ? _c : '';
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/" + facilityId + "/scanIdGeneral?scanId=" + encodeURIComponent(scanId) + "&ownerPartyId=" + activeOrgId, { headers: authHeaders() })];
                case 2:
                    response = _e.sent();
                    data = response === null || response === void 0 ? void 0 : response.data;
                    locationSeqId = data === null || data === void 0 ? void 0 : data.locationSeqId;
                    locationTypeEnumId_1 = (_d = data === null || data === void 0 ? void 0 : data.facilityLocation) === null || _d === void 0 ? void 0 : _d.locationTypeEnumId;
                    if ((data === null || data === void 0 ? void 0 : data.messages) ||
                        !locationSeqId ||
                        ['FltCart', 'FltPack'].includes(locationTypeEnumId_1)) {
                        return [2 /*return*/, { ok: false, error: 'Incorrect receiving location, scan again' }];
                    }
                    matched = shipmentLocationTypeList === null || shipmentLocationTypeList === void 0 ? void 0 : shipmentLocationTypeList.find(function (entry) { return (entry === null || entry === void 0 ? void 0 : entry.enumId) === locationTypeEnumId_1; });
                    return [2 /*return*/, {
                            ok: true,
                            locationSeqId: locationSeqId,
                            locationType: (matched === null || matched === void 0 ? void 0 : matched.description) || locationTypeEnumId_1 || '',
                            locationTypeEnumId: locationTypeEnumId_1
                        }];
                case 3:
                    _a = _e.sent();
                    return [2 /*return*/, { ok: false, error: 'Failed to validate location. Try again.' }];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [shipmentLocationTypeList]);
    // Search the facility's locations by type (and optional term). Used to
    // offer Receiving locations by default and lazily search Bulk/Pick. Labels
    // match the suggested-location format: "<locationSeqId> - <type>"
    // (e.g. "0801 - Receiving").
    var searchLocations = useCallback(function (term, types) { return __awaiter(void 0, void 0, Promise, function () {
        var facilityId, response, list, _a;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    facilityId = (_b = localStorage.getItem('facilityId')) !== null && _b !== void 0 ? _b : '';
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/" + facilityId + "/locations", {
                            params: {
                                locationTypeEnumId: types.join(','),
                                term: (term === null || term === void 0 ? void 0 : term.trim()) || undefined,
                                limit: 50
                            },
                            headers: authHeaders()
                        })];
                case 2:
                    response = _d.sent();
                    list = ((_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.locations) || [];
                    return [2 /*return*/, list
                            .filter(function (loc) { return loc === null || loc === void 0 ? void 0 : loc.locationSeqId; })
                            .map(function (loc) {
                            var _a;
                            var typeLabel = ((_a = shipmentLocationTypeList === null || shipmentLocationTypeList === void 0 ? void 0 : shipmentLocationTypeList.find(function (entry) { return (entry === null || entry === void 0 ? void 0 : entry.enumId) === loc.locationTypeEnumId; })) === null || _a === void 0 ? void 0 : _a.description) || '';
                            return {
                                key: loc.locationSeqId,
                                value: typeLabel
                                    ? loc.locationSeqId + " - " + typeLabel
                                    : loc.locationSeqId,
                                locationTypeEnumId: loc.locationTypeEnumId
                            };
                        })];
                case 3:
                    _a = _d.sent();
                    return [2 /*return*/, []];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [shipmentLocationTypeList]);
    var addScan = useCallback(function (rawBarcode, qty) {
        if (qty === void 0) { qty = 1; }
        return __awaiter(void 0, void 0, void 0, function () {
            var barcode, quantity, facilityId, activeOrgId, response_1, productId_1, matched_1, product, row, e_1;
            var _a;
            var _b, _c, _d, _e, _f, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        barcode = rawBarcode.trim();
                        if (!barcode)
                            return [2 /*return*/];
                        quantity = Number.isFinite(qty) && qty > 0 ? Math.floor(qty) : 1;
                        setScanError('');
                        setProductNotAssociatedWithShipment({});
                        setPendingUnassociatedRow(null);
                        setIsScanLoading(true);
                        _h.label = 1;
                    case 1:
                        _h.trys.push([1, 3, 4, 5]);
                        facilityId = (_b = localStorage.getItem('facilityId')) !== null && _b !== void 0 ? _b : '';
                        activeOrgId = (_c = localStorage.getItem('activeOrgId')) !== null && _c !== void 0 ? _c : '';
                        return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/" + facilityId + "/scanIdGeneral?scanId=" + encodeURIComponent(barcode) + "&ownerPartyId=" + activeOrgId, { headers: authHeaders() })];
                    case 2:
                        response_1 = _h.sent();
                        productId_1 = (_d = response_1 === null || response_1 === void 0 ? void 0 : response_1.data) === null || _d === void 0 ? void 0 : _d.productId;
                        if (!productId_1) {
                            setScanError('Incorrect Product UPC, scan again');
                            return [2 /*return*/];
                        }
                        matched_1 = shipmentItemDetailList === null || shipmentItemDetailList === void 0 ? void 0 : shipmentItemDetailList.find(function (item) { return (item === null || item === void 0 ? void 0 : item.productId) === productId_1; });
                        if (!matched_1) {
                            product = ((_e = response_1 === null || response_1 === void 0 ? void 0 : response_1.data) === null || _e === void 0 ? void 0 : _e.product) || {};
                            row = {
                                productId: productId_1,
                                quantity: quantity,
                                productSku: product.productSku || product.pseudoId,
                                productUpc: product.productUpc,
                                productName: product.productName,
                                productImagePath: product.productImagePath,
                                expectedQuantity: 0,
                                quantityAcceptedTotal: 0
                            };
                            if (!approvedUnassociatedProductIdsRef.current.has(productId_1)) {
                                setPendingUnassociatedRow(row);
                                setProductNotAssociatedWithShipment((_a = {}, _a[barcode] = true, _a));
                                setScanError('This product is not associated with the shipment.');
                                return [2 /*return*/];
                            }
                        }
                        if ((matched_1 === null || matched_1 === void 0 ? void 0 : matched_1.ownerPartyId) && matched_1.ownerPartyId !== activeOrgId) {
                            setScanError("Incorrect Product UPC, Org don't match");
                            return [2 /*return*/];
                        }
                        setQueue(function (prev) {
                            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                            var existing = prev.find(function (row) { return row.productId === productId_1; });
                            if (existing) {
                                return prev.map(function (row) {
                                    return row.productId === productId_1
                                        ? __assign(__assign({}, row), { quantity: row.quantity + quantity }) : row;
                                });
                            }
                            return __spreadArray(__spreadArray([], prev, true), [
                                matched_1
                                    ? __assign({ productId: productId_1, quantity: quantity, productSku: matched_1.productSku, productUpc: matched_1.productUpc, productName: matched_1.productName, productImagePath: matched_1.productImagePath, expectedQuantity: matched_1.quantity, quantityAcceptedTotal: matched_1.quantityAcceptedTotal }, (__containerizedV2Flag__
                                        ? { quantityRejectedTotal: matched_1.quantityRejectedTotal }
                                        : {})) : {
                                    productId: productId_1,
                                    quantity: quantity,
                                    productSku: ((_b = (_a = response_1 === null || response_1 === void 0 ? void 0 : response_1.data) === null || _a === void 0 ? void 0 : _a.product) === null || _b === void 0 ? void 0 : _b.productSku) ||
                                        ((_d = (_c = response_1 === null || response_1 === void 0 ? void 0 : response_1.data) === null || _c === void 0 ? void 0 : _c.product) === null || _d === void 0 ? void 0 : _d.pseudoId),
                                    productUpc: (_f = (_e = response_1 === null || response_1 === void 0 ? void 0 : response_1.data) === null || _e === void 0 ? void 0 : _e.product) === null || _f === void 0 ? void 0 : _f.productUpc,
                                    productName: (_h = (_g = response_1 === null || response_1 === void 0 ? void 0 : response_1.data) === null || _g === void 0 ? void 0 : _g.product) === null || _h === void 0 ? void 0 : _h.productName,
                                    productImagePath: (_k = (_j = response_1 === null || response_1 === void 0 ? void 0 : response_1.data) === null || _j === void 0 ? void 0 : _j.product) === null || _k === void 0 ? void 0 : _k.productImagePath,
                                    expectedQuantity: 0,
                                    quantityAcceptedTotal: 0
                                }
                            ], false);
                        });
                        void fetchSuggestedLocationsFor(productId_1);
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _h.sent();
                        setScanError(((_g = (_f = e_1 === null || e_1 === void 0 ? void 0 : e_1.response) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.errors) || 'Failed to look up product. Try again.');
                        return [3 /*break*/, 5];
                    case 4:
                        setIsScanLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }, [shipmentItemDetailList, fetchSuggestedLocationsFor, __containerizedV2Flag__]);
    var proceedUnassociatedScan = useCallback(function () {
        if (!pendingUnassociatedRow)
            return;
        approvedUnassociatedProductIdsRef.current.add(pendingUnassociatedRow.productId);
        setQueue(function (prev) {
            var existing = prev.find(function (row) { return row.productId === pendingUnassociatedRow.productId; });
            if (existing) {
                return prev.map(function (row) {
                    return row.productId === pendingUnassociatedRow.productId
                        ? __assign(__assign({}, row), { quantity: row.quantity + pendingUnassociatedRow.quantity }) : row;
                });
            }
            return __spreadArray(__spreadArray([], prev, true), [pendingUnassociatedRow], false);
        });
        void fetchSuggestedLocationsFor(pendingUnassociatedRow.productId);
        setPendingUnassociatedRow(null);
        setProductNotAssociatedWithShipment({});
        setScanError('');
    }, [pendingUnassociatedRow, fetchSuggestedLocationsFor]);
    var cancelUnassociatedScan = useCallback(function () {
        setPendingUnassociatedRow(null);
        setProductNotAssociatedWithShipment({});
        setScanError('');
    }, []);
    var removeRow = useCallback(function (productId) {
        setQueue(function (prev) { return prev.filter(function (row) { return row.productId !== productId; }); });
    }, []);
    var updateQty = useCallback(function (productId, qty) {
        var next = Number.isFinite(qty) && qty > 0 ? Math.floor(qty) : 1;
        setQueue(function (prev) {
            return prev.map(function (row) { return (row.productId === productId ? __assign(__assign({}, row), { quantity: next }) : row); });
        });
    }, []);
    var clear = useCallback(function () {
        setQueue([]);
        setLocationCache({});
        setScanError('');
        setPendingUnassociatedRow(null);
        setProductNotAssociatedWithShipment({});
        approvedUnassociatedProductIdsRef.current.clear();
    }, []);
    var computeOverReceiveTotal = useCallback(function () {
        var over = 0;
        queue.forEach(function (row) {
            var _a, _b, _c;
            var handled = ((_a = row.quantityAcceptedTotal) !== null && _a !== void 0 ? _a : 0) + ((_b = rejectedQtyByProductId[row.productId]) !== null && _b !== void 0 ? _b : 0);
            var remaining = ((_c = row.expectedQuantity) !== null && _c !== void 0 ? _c : 0) - handled;
            if (row.quantity > Math.max(remaining, 0)) {
                over += row.quantity - Math.max(remaining, 0);
            }
        });
        return over;
    }, [queue, rejectedQtyByProductId]);
    var submit = useCallback(function (_a) {
        var locationSeqId = _a.locationSeqId, _b = _a.isDefective, isDefective = _b === void 0 ? false : _b;
        return __awaiter(void 0, void 0, void 0, function () {
            var activeOrgId, data, succeeded, e_2;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!queue.length || !locationSeqId)
                            return [2 /*return*/];
                        activeOrgId = (_c = localStorage.getItem('activeOrgId')) !== null && _c !== void 0 ? _c : '';
                        data = queue.map(function (row) { return ({
                            productId: row.productId,
                            locationSeqId: locationSeqId,
                            receivingType: 'RtPiece',
                            pieceQuantity: row.quantity,
                            partyId: activeOrgId
                        }); });
                        setIsSubmitting(true);
                        succeeded = false;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, dispatch(receiveItems({
                                __containerizedV2Flag__: __containerizedV2Flag__,
                                data: data,
                                shipmentId: shipmentId,
                                isDefective: isDefective,
                                // Keep the user on the Quick view; suppress subscreen jumps.
                                setCurrentActiveSubscreen: function () { },
                                resetHandler: function () { },
                                setSelectedLocation: function () { },
                                onValidateShipmentHandler: function (args) { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                succeeded = true;
                                                return [4 /*yield*/, onAfterReceive(__assign(__assign({}, args), { isDefective: isDefective }))];
                                            case 1:
                                                _a.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); }
                            }))];
                    case 2:
                        _d.sent();
                        if (succeeded) {
                            if (!isDefective) {
                                setProductLocationPreferences(function (prev) {
                                    var next = __assign({}, prev);
                                    queue.forEach(function (row) {
                                        next[row.productId] = locationSeqId;
                                    });
                                    writeStoredPreferences(next);
                                    return next;
                                });
                            }
                            clear();
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        e_2 = _d.sent();
                        notification['error']({
                            message: 'Error',
                            description: (e_2 === null || e_2 === void 0 ? void 0 : e_2.message) || 'Failed to receive items.'
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        setIsSubmitting(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }, [queue, shipmentId, dispatch, onAfterReceive, clear, __containerizedV2Flag__]);
    return {
        queue: queue,
        suggestedLocations: suggestedLocations,
        scanError: scanError,
        productNotAssociatedWithShipment: productNotAssociatedWithShipment,
        isScanLoading: isScanLoading,
        isSubmitting: isSubmitting,
        productLocationPreferences: productLocationPreferences,
        addScan: addScan,
        proceedUnassociatedScan: proceedUnassociatedScan,
        cancelUnassociatedScan: cancelUnassociatedScan,
        removeRow: removeRow,
        updateQty: updateQty,
        clear: clear,
        submit: submit,
        validateLocation: validateLocation,
        searchLocations: searchLocations,
        computeOverReceiveTotal: computeOverReceiveTotal
    };
};
export default useReceivingQueue;
